export const PAGINATED_CACHE_PAGE_LIMIT = 2;

export const shouldPrefetchPaginatedPage = (pageIndex: number) =>
  Number.isFinite(pageIndex) &&
  pageIndex + 1 < PAGINATED_CACHE_PAGE_LIMIT;
